import SocialProofCard from '@/components/_atoms/social-proof-cards/SocialProofCard';
import Star from '@/components/Star';
import { mediaBreakpointUp } from '@/styles/layout/utils';
import { customTextSize, remCalc } from '@/styles/typography/utils';
import { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';

export interface SocialProofQuoteWithStarsCardProps extends PropsWithChildren {
  stars: number;
}

const SocialProofQuoteWithStarsCard: FC<SocialProofQuoteWithStarsCardProps> = (props) => {
  return (
    <SocialProofCard>
      <Content>{props.children}</Content>

      <StarWrapper>
        {Array(5)
          .fill('')
          .map((s, i) => (
            <Star key={`star-${i}`} width={32} fillPercent={Math.max(0, Math.min(1, props.stars - i))} />
          ))}
      </StarWrapper>
    </SocialProofCard>
  );
};

export default SocialProofQuoteWithStarsCard;

// Styled Components

const Content = styled.div`
  ${customTextSize(18, 27)};
  margin-top: ${remCalc(1)}; // prevent gradient from peeking on card scale
  width: 100%;
  margin-bottom: ${remCalc(20)};

  strong {
    background: linear-gradient(90deg, #ff2b73 19.41%, #ff6c35 80.07%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  ${mediaBreakpointUp('tablet')} {
    ${customTextSize(24, 34)};
  }
`;

const StarWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  column-gap: ${remCalc(16)};
`;
